const stepEightContentTemplate = ({ classes, sections }) => {
	return `
        <div class="${classes.rootClass}__section">
            <div class="${classes.rootClass}__event-intro">
                <h3 data-event-signup-confirmation-title>${sections.confirmationTitle}</h3>
                <span data-event-signup-confirmation-text>${sections.confirmationText}</span>
            </div>
        </div>
    `;
};

export default stepEightContentTemplate;
